import type { IFilter } from '@models/Filter'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../../gateways/api'
import type { AssignedBijlagenSearch } from '../types/AssignedBijlagenSearch'

export { initialState, createFilters, searchAssignedBijlagen }

const AANSLUITING_PROJECT_TYPES = ['Aanvraag']

const initialState: AssignedBijlagenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      gebied: [],
      documentsoort: [],
      assignedTo: [],
      fromWeek: '',
      toWeek: '',
      fromGeplandeUitvoeringsdatum: null,
      toGeplandeUitvoeringsdatum: null,
      labels: [],
      review: false,
      myList: false,
      kpi: '',
    },
    sort: { sortBy: 'created.date', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  gebied,
  documentsoort,
  assignedTo,
  toWeek,
  fromWeek,
  fromGeplandeUitvoeringsdatum,
  toGeplandeUitvoeringsdatum,
  labels,
  review,
  myList,
  kpi,
}) => {
  const filters: IFilter[] = [
    { name: 'isActive', value: true, operator: 'eq' },
    {
      name: 'entity.projecttype',
      value: AANSLUITING_PROJECT_TYPES,
      operator: 'in',
    },
  ]

  if (documentsoort && documentsoort.length > 0)
    filters.push({
      name: 'documentsoort',
      value: documentsoort,
      operator: 'in',
    })
  if (gebied && gebied.length > 0)
    filters.push({
      name: 'entity.gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })

  if (assignedTo && assignedTo.length > 0)
    filters.push({
      name: 'assignedTo',
      value: assignedTo.map(({ label }) => label),
      operator: 'in',
    })
  if (fromWeek)
    filters.push({ name: 'dueWeek', value: fromWeek, operator: 'gte' })
  if (toWeek) filters.push({ name: 'dueWeek', value: toWeek, operator: 'lte' })
  if (fromGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: startOfDay(fromGeplandeUitvoeringsdatum),
      operator: 'gte',
    })
  }
  if (toGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: endOfDay(toGeplandeUitvoeringsdatum),
      operator: 'lte',
    })
  }

  const status = review ? ['review'] : ['assigned', 'uploaded', 'review']
  filters.push({
    name: 'status',
    value: status,
    operator: 'in',
  })

  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  if (kpi) {
    filters.push({ name: 'kpi', value: kpi, operator: 'eq' })
  }

  return filters
}

const searchAssignedBijlagen = async ({
  query,
}: {
  query: AssignedBijlagenSearch['query']
}): Promise<AssignedBijlagenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/bijlageassigned/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
